import { useCallback, useRef } from 'react';
export function useImagePan({ dispatch, getState, disabled }) {
    const dragRef = useRef(null);
    const onPointerDown = useCallback((e) => {
        if (disabled || e.button !== 0)
            return;
        // Don't start panning if clicking a button or control
        if (e.target.closest('button, input, [role="toolbar"]'))
            return;
        const state = getState();
        dragRef.current = {
            startX: e.clientX,
            startY: e.clientY,
            startPanX: state.panX,
            startPanY: state.panY,
        };
        e.target.setPointerCapture(e.pointerId);
        e.preventDefault();
    }, [disabled, getState]);
    const onPointerMove = useCallback((e) => {
        if (!dragRef.current)
            return;
        const dx = e.clientX - dragRef.current.startX;
        const dy = e.clientY - dragRef.current.startY;
        dispatch({
            type: 'PAN',
            panX: dragRef.current.startPanX + dx,
            panY: dragRef.current.startPanY + dy,
        });
    }, [dispatch]);
    const onPointerUp = useCallback(() => {
        dragRef.current = null;
    }, []);
    return { onPointerDown, onPointerMove, onPointerUp };
}
